const EditarLocalAtendimentoSkeleton = () => {
  return (
    <div className="u-pagina-centro">
      <div className="cartao u-p-2">
        <div
          className="skeleton skeleton-titulo u-mb-2"
          style={{ width: "40%" }}
        />
        <div
          className="skeleton skeleton-linha u-mb-2"
          style={{ height: "3rem" }}
        />
        <div
          className="skeleton skeleton-linha u-mb-2"
          style={{ height: "3rem" }}
        />
        <div
          className="skeleton skeleton-linha u-mb-2"
          style={{ height: "3rem" }}
        />
        <div
          className="skeleton skeleton-linha u-mb-2"
          style={{ height: "3rem" }}
        />
      </div>
    </div>
  );
};

export default EditarLocalAtendimentoSkeleton;
